import { useEffect, useState } from "react";
import { useUserContextActionsHook, useUserContextValueHook } from "../../../contexts/UserContextProvider";
import { TopNavBar } from "../../../layouts/TopNavBar/TopNavBar";
import { WegetAnonymous } from "./wegets/weget-anonymous/weget-anonymous";
import { WegetLoginMethods } from "./wegets/weget-login-methods/weget-login-methods";
import { WegetLogoutButton } from "./wegets/weget-logout-button/weget-logout-button";
import { WegetProfileBadge } from "./wegets/weget-profile-badge/weget-profile-badge";
import { WegetPasswordChange } from "./wegets/weget-password-change/weget-password-change";
import { WegetAccountDeletion } from "./wegets/weget-account-deletion/weget-account-deletion";
import { WegetPhoneSetting } from "./wegets/weget-phone-setting/weget-phone-setting";
import { WegetSubscriptions } from "./wegets/weget-subscriptions/WegetSubscriptions";
import { useUserInfoQuery } from "@/hooks/ReactQuery/UserInfoReactQuery/UserInfoReactQuery";
import { useAuthContextValueHook } from "@/contexts/AuthContext";

export function MainView(props) {
    const authContextValueHook = useAuthContextValueHook();

    const userContextActionsHook = useUserContextActionsHook();

    const { data, isPending } = useUserInfoQuery({ isLoggedIn: authContextValueHook?.isLoggedIn, isReady: authContextValueHook?.isReady });

    useEffect(() => {
        if (data && !isPending) {
            userContextActionsHook.onSetUser(data?.data?.data);
        }
    }, [data, isPending]);

    return (
        <div className="min-h-screen bg-[#f5f5f7] pb-24">
            <TopNavBar />
            {!(authContextValueHook?.isLoggedIn && authContextValueHook?.isReady) ?
                <>
                    <WegetAnonymous />
                </>
                :
                <>
                    <WegetProfileBadge />
                    <WegetLogoutButton />
                    <WegetSubscriptions />
                    <WegetLoginMethods />
                    <WegetPhoneSetting />
                    <WegetPasswordChange />
                    <WegetAccountDeletion />
                </>
            }
        </div>
    );
}